import { styled } from "@mui/material/styles";
import Tooltip from '@mui/material/Tooltip';

export const FairGoTooltip = styled(Tooltip)((theme) => ({
  tooltip: {
    backgroundColor: 'white',
    boxShadow: '1px 2px lightgray',
    color: 'gray',
    border: '1px solid lightgray',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStyle: 'italic'
  },
}))
